$(document).on("click",".upsell_product_addToCart",function(e) {
  e.preventDefault(); // Prevent default button behavior
  // Get variant ID from data attribute or any other source
  $(this).addClass('is-loading');

  if($(this).find('input').is(":checked")){
    $(this).find('input').removeAttr('checked');
    
    var variantId = $(this).find('input').val();
    var quantity = 0; // Set the quantity to add (can be dynamic if needed)
  
    // AJAX request to add product to cart
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: variantId,
        quantity: quantity
      },
      dataType: 'json',
      success: function (response) {
        console.log('Item added to cart:', response);
  
        updateCart();
      },
      error: function (error) {
        console.log('Error adding item to cart:', error);
      }
    });
  }else{
    $(this).find('input').attr("checked",true);
    
    var variantId = $(this).find('input').val();
    var quantity = 1; // Set the quantity to add (can be dynamic if needed)
  
    // AJAX request to add product to cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity
      },
      dataType: 'json',
      success: function (response) {
        console.log('Item added to cart:', response);
  
        updateCart();
      },
      error: function (error) {
        console.log('Error adding item to cart:', error);
      }
    });
  }
});

function updateCart() {
  fetch(`${window.location.href}`).then((response) => {
    return response.text();
  })
  .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('cart-drawer');
    document.querySelector('cart-drawer').innerHTML = html.innerHTML;
  })
  .catch(e => {
    console.error(e);
  })
  .finally(() => {
  });
}